export const isEmptyArray = (value: unknown): boolean => {
  return Array.isArray(value) && value.length > 0;
};

/**
 * Finds an item by id within a flat or nested property_set array.
 * Returns the matching entry or undefined if not found.
 */
export const findProperty = <T extends { id?: any }>(
  id: any,
  propertySet: T[] | undefined
): T | undefined => {
  if (!propertySet) return undefined;
  return propertySet.find((p) => p.id === id);
};
